import { PageLayout, PageLayoutFull } from '@components/page-layout/page-layout';

export default function LocalhostDetector() {
    if (window.location.hostname !== 'localhost.gowwise.com') return null;

    const style = {
        width: '100%',
        minHeight: '150px',
        display: 'grid',
        placeItems: 'center',
    };

    return (
        <PageLayout>
            <PageLayoutFull subgrid bgColor='akTeal'>
                <div style={style}>YOUR ON LOCAL HOST</div>
            </PageLayoutFull>
        </PageLayout>
    );
}
